import VideoCard from "@/components/feature/VideoCard";
import type { VideoItem } from "@/types/content";

interface HotVideosProps {
  videos: VideoItem[];
  onPlay: (video: VideoItem) => void;
}

export default function HotVideos({ videos, onPlay }: HotVideosProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {videos.map((video) => (
        <VideoCard key={video.id} video={video} onPlay={onPlay} />
      ))}
    </div>
  );
}